define('modules/profiles/cards/views/card.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette",
    'moment',
    "modules/base/models/uniquify.companies.model",
    "modules/profiles/models/card.model",
    "modules/advanceSearch/models/industry.codes.model",
    //'modules/base/models/news.article.model', //included news article model
    'modules/profiles/models/inferred.email.model',
    'modules/base/views/model.view',
    'modules/profiles/cards/views/role.bin.view',
    'text!modules/profiles/cards/templates/common.end.template.html',
    'text!modules/profiles/cards/templates/user.defined.template.html',
    'text!modules/profiles/cards/templates/employment.card.template.html',
    'text!modules/profiles/cards/templates/education.card.template.html',
    'text!modules/profiles/cards/templates/employee.card.template.html',
    'text!modules/profiles/cards/templates/phone.number.card.html',
    'text!modules/profiles/cards/templates/email.card.template.html',
    'text!modules/profiles/cards/templates/address.card.template.html',
    'text!modules/profiles/cards/templates/org.desc.template.html',
    'text!modules/profiles/cards/templates/profile.card.template.html',
    'text!modules/profiles/cards/templates/org.profile.card.template.html',
    'text!modules/profiles/cards/templates/article.image.card.template.html',
    'text!modules/profiles/cards/templates/hg.template.html',
    'text!modules/profiles/cards/templates/website.template.html',
    'text!modules/profiles/cards/templates/company.details.template.html',
    'text!modules/profiles/cards/templates/favorite.role.template.html', //favorite role temp
    'text!modules/profiles/cards/templates/inferred.email.card.template.html',
    'text!modules/profiles/cards/templates/relationship.score.card.template.html',
    'text!modules/profiles/cards/templates/company.relationship.score.card.template.html',
    'text!modules/profiles/cards/templates/affliated.relationship.score.card.template.html',
    'text!modules/profiles/cards/templates/sic.codes.card.template.html',
    'text!modules/profiles/cards/templates/naics.codes.card.template.html',
    'text!modules/profiles/cards/templates/industry.keywords.card.template.html',
    'text!modules/profiles/cards/templates/company.parent.details.template.html',
    'text!modules/profiles/cards/templates/company.finance.details.template.html'

], function(Prospector,$, _,Backbone,
            Marionette,
            Moment,
            UniquifyCompaniesModel,
            BoardCardModel,
            IndustryCodesModel,
            //NewsArticleModel, //include news article model
            InferredEmailModel,
            BaseView,
            RoleBinView,
            CommonTemplate,
            TemplateType1,
            TemplateType2,
            TemplateType3,
            TemplateType6,
            TemplateType7,
            TemplateType8,
            TemplateType9,
            TemplateType10,
            TemplateType11,
            TemplateType12,
            TemplateType13,
            TemplateType14,
            TemplateType15,
            TemplateType16,
            TemplateType17, //favorite roles template
            TemplateType18,
            TemplateType19,
            TemplateType20,
            TemplateType21,
            TemplateType22,
            TemplateType23,
            TemplateType24,
            TemplateType25,
            TemplateType26

) {
    var BoardView = BaseView.extend({
        className: 'card col-md-12 animated ',
        commonTemplate: _.template(CommonTemplate),
        mEvents:function(){
            return{
                'click .addAComment'             : 'openAddComment',
                'click .personName.clickable'   : 'clickPersonName',
                'click .company.clickable'      : 'clickOrgName',
           //     'click .title.article.clickable': 'openMediaLink',
                //'click .website.clickable'     : 'openWebsiteLink',
                'click .editArticle'           : 'procEditArticle',
                'click .hideBtn' :  'procHideArticle',
                'click .retrieveInferredEmail' :  'procRetrieveInferredEmail',
                'click .linkedIn'         : 'procLinkedIn',
                'click .sicCodes .caret-icon, .naicsCodes .caret-icon': 'toggleCaretIcon',
                'click .seeMore' : 'toggleListener'

            };
        },
        initialize: function(options){
            this.parent = options.parent;
            this.model = options.model;
            switch(this.model.typeId){
                case 26:{
                    this.template = _.template(TemplateType26);
                    break;
                }
                case 25:{
                    this.template = _.template(TemplateType25);
                    break;
                }
                case 24:{
                    this.template = _.template(TemplateType24);
                    break;
                }
                case 23:{
                    this.template = _.template(TemplateType23);
                    break;
                }
                case 22: {
                    this.template = _.template(TemplateType22);
                    break;
                }
                case 21:{
                    this.template = _.template(TemplateType21);
                    break;
                }
                case 20:{
                    this.template = _.template(TemplateType20);
                    break;
                }
                case 19: {
                    this.template = _.template(TemplateType19);
                    break;
                }
                case 18: {
                    this.template = _.template(TemplateType18);
                    break;
                }
                case 17: {
                    this.template = _.template(TemplateType17);
                    break;
                }
                case 16:{
                    this.template = _.template(TemplateType16);
                    break;
                }
                case 15:{
                    this.template = _.template(TemplateType15);
                    break;
                }
                case 14:{
                    this.template = _.template(TemplateType14);
                    break;
                }
                case 13:{
                    this.template = _.template(TemplateType13);
                    break;
                }
                case 12:{
                    this.template = _.template(TemplateType12);
                    break;
                }
                case 11:{
                    this.template = _.template(TemplateType11);
                    break;
                }
                case 10:{
                    this.template = _.template(TemplateType10);
                    break;
                }
                case 9:{
                    this.template = _.template(TemplateType9);
                    break;
                }
                case 8:{
                    this.template = _.template(TemplateType8);
                    break;
                }
                case 7:{
                    this.template = _.template(TemplateType7);
                    break;
                }
                case 6:{
                    this.template = _.template(TemplateType6);
                    break;
                }
                case 3:
                case 4:
                case 5:{
                    this.template = _.template(TemplateType3);
                    break;
                }
                case 2:{
                    this.template = _.template(TemplateType2);
                    break;
                }
                case 1:
                default:{
                    this.template = _.template(TemplateType1);
                    break;
                }
            }
            BaseView.prototype.initialize.call(this, options);
        },
        buildModel:function(){
            this.model = new BoardCardModel(this.model);
        },
        fetchModel:function(){
            this.procResponse();
        },
        onRender:function(){
            BaseView.prototype.onRender.call(this);
            this.$('img').on('error', $.proxy(this.replaceImage,this));
            // this.$('.icon-phone').attr("class","relpro-sk relpro-sk-phone-direct");
        },
        procResponse:function(){
            switch(this.model.get('typeId')){
                case 1:{
                    this.buildUserDefinedCard();
                    break;
                }
                case 2:{
                    this.buildEmploymentCard();
                    break;
                }
                case 3:
                case 4:
                case 5:{
                    this.buildEducationCard();
                    break;
                }
                case 6:{
                    this.buildEmployeeCard();
                    break;
                }
                case 7:{
                    this.buildPhoneNumber();
                    break;
                }
                case 8:{
                    this.buildEmail();
                    break;
                }
                case 9:{
                    this.buildAddress();
                    break;
                }
                case 10:{
                    this.buildDescription();
                    break;
                }
                case 11:{
                    this.buildProfileCard();
                    break;
                }
                case 12:{
                    this.buildOrgProfileCard();
                    break;
                }
                case 13:{
                    this.buildMediaArticle();
                    break;
                }
                case 14:{
                    this.buildHG();
                    break;
                }
                case 15:{
                    this.buildWebsiteLink();
                    break;
                }
                case 16:{
                    this.buildCompanyDetails();
                    break;
                }
                case 17: {
                    this.buildFavoriteRoles();
                    break;
                }
                case 18: {
                    this.buildInferredEmail();
                    break;
                }
                case 19: {
                    this.buildRelationshipScore();
                    break;
                }
                case 20: {
                    this.buildCompanyRelationshipScore();
                    break;
                }
                case 21: {
                    this.buildAffiliatedRelationshipScore();
                    break;
                }
                case 22: {
                    this.buildSicScores();
                    break;
                }
                case 23: {
                    this.buildNaicsScores();
                    break;
                }
                case 24: {
                    this.buildIndustryKeywords();
                    break;
                }
                case 25: {
                    this.buildParentCompanyDetails();
                    break;
                }
                case 26: {
                    this.buildFinanceCompanyDetails();
                    break;
                }
            }
            if(this.model.canModifyCard()){
                var commentText = "";
                if(this.model.get('totalComments') > 1){
                    commentText = 'View ' + this.model.get('totalComments') + ' Comments';
                } else if(this.model.get('totalComments') == 1){
                    commentText = 'View 1 Comment';
                } else {
                    commentText = 'Add a Comment';
                }
                this.$('.commentsText').html(commentText);
                this.$('.commentRow').show();
            }
            if(this.model.get('typeId') != 13 && //Media
                this.model.get('typeId') != 1 && //Media
                this.model.get('typeId') != 16){ //User Defined
                this.$('.sourceName').html(window.utils.identity.makeSourceName(
                    this.model.get('source')?this.model.get('source').sourceId:0)
                );
            }
        },
        toggleCaretIcon: function (e) {
            var caret = $(e.currentTarget).closest('li').children('.caret-icon');
            if (caret.hasClass('fa-caret-down')) {
                caret.removeClass('fa-caret-down').addClass('fa-caret-right');
            } else {
                caret.removeClass('fa-caret-right').addClass('fa-caret-down');
            }
            $(e.currentTarget).closest('li').children('ul').slideToggle(500);
        },
        toggleListener: function(e){
            var that = this;
            this.$('.moreContent').on('hidden.bs.collapse', function () {
                $(e.currentTarget).text('See more');
                that.$('.ellipses').show();
                that.$('.moreContent').hide();
            });
            this.$('.moreContent').on('shown.bs.collapse', function () {
                $(e.currentTarget).text('See less');
                that.$('.ellipses').hide();
                that.$('.moreContent').css('display','inline');
            });
        },
        openAddComment:function(){
            Prospector.trigger('showFullCardModal', {parent: this});
        },
        buildInferredEmail:function(){
            var model = this.model.get('record');
            if(model.email != ""){
                this.$('.showLink').remove();
                this.renderEmailAndAccuracy(model.email, model.accuracy);
            } else {
                //do nothing
            }
        },
        buildRelationshipScore:function(){
            var model = this.model.get('record');
            if(model.relationshipScore != undefined){
                this.$('.relationshipScore').append("Relationship Score: " + model.relationshipScore + "");
            } else {
                //do nothing
            }
        },
        buildCompanyRelationshipScore:function(){
            var model = this.model.get('record');
            if(model.connections != undefined && model.connections > 0){
                // this.$('.connections').append("Connections: " + model.connections);
                // this.$('.avgScore').append("Average Score: " + model.avgScore);
                this.$('.colleagues').append("Colleagues: " + model.colleagues);
                this.$('.contacts').append("Contacts: " + model.contacts);
            } else {
                //do nothing
            }
        },
        buildAffiliatedRelationshipScore:function(){
            var model = this.model.get('record');
            this.$('.coworker').append("<span style='font-weight: 400'>Peer: </span><a class='clickable' href='mailto:" + model.userEMail + "'>" + model.userFirstName + " " + model.userLastName + "</a>");
            this.$('.coworker .clickable').click(function (){
                window.open("mailto:"+model.userEmail, '_blank');
            });
            this.$('.relationshipScore').append("<span style='font-weight: 400'>Relationship Score:</span> " + model.relationshipScore);
        },
        buildSicScores: function() {
            var model = this.model.get('record');
            if (model.sicCodes.length == 0) {
                this.$('.sicCodes').append('N/A');
            }
            for (var i = 0; i < model.sicCodes.length; i++) {
                var rootList = $('<li>', {
                    style: "list-style: none;",
                });
                rootList.append($('<i>', {
                    class: model.sicCodes[i].level2Codes.length != 0 ? "caret-icon fa fa-caret-right mRight10 fLeft" : "",
                }));
                rootList.append($('<label>', {
                    text: model.sicCodes[i].description + ' (' + model.sicCodes[i].code + ')'
                }));
                if (model.sicCodes[i].level2Codes.length != 0 ) {
                    var level2Codes = model.sicCodes[i].level2Codes;
                    var ul = $('<ul>', {
                        style: 'display: none'
                    });
                    var list = $('<li>', {
                        class: "subList",
                        style: "list-style: none;",
                    });

                    var label = $('<label>', {
                    });
                    list.append(label);

                    var arr = [];
                    for (var j = 0; j < level2Codes.length; j++) {
                        arr.push(level2Codes[j].description + ' (' + level2Codes[j].code + ')');
                    }
                    var lists = this.appendByCommaNoAnd2(arr);
                    label.html(lists);

                    rootList.append(ul);
                    ul.append(list);
                }
                this.$('.sicCodes').append(rootList);
            }
        },
        buildNaicsScores: function() {
            var model = this.model.get('record');
            if (model.naicsCodes.length == 0) {
                this.$('.naicsCodes').append('N/A');
            }
            for (var i = 0; i < model.naicsCodes.length; i++) {
                var rootList = $('<li>', {
                    style: "list-style: none;",
                });
                rootList.append($('<i>', {
                    class: model.naicsCodes[i].level2Codes.length != 0 ? "caret-icon fa fa-caret-right mRight10 fLeft" : "",
                }));
                rootList.append($('<label>', {
                    text: model.naicsCodes[i].description + ' (' + model.naicsCodes[i].code + ')'
                }));
                if (model.naicsCodes[i].level2Codes.length != 0) {
                    var level2Codes = model.naicsCodes[i].level2Codes;
                    var ul = $('<ul>', {
                        style: 'display: none'
                    });
                    var list = $('<li>', {
                        class: "subList",
                        style: "list-style: none;",
                    });

                    var label = $('<label>', {
                    });
                    list.append(label);

                    var arr = [];
                    for (var j = 0; j < level2Codes.length; j++) {
                        arr.push(level2Codes[j].description + ' (' + level2Codes[j].code + ')');
                    }
                    var lists = this.appendByCommaNoAnd2(arr);
                    label.html(lists);

                    rootList.append(ul);
                    ul.append(list);
                }
                this.$('.naicsCodes').append(rootList);
            }
        },
        buildIndustryKeywords: function(){
            var model = this.model.get('record');
            var list = this.appendByCommaNoAnd(model.industryKeywords);
            // this.$('.industryKeywords').html(list);
            if(list.length == 0){
                this.$('.industryKeywords').html("N/A");
            }
            if (list.length > 150) {
                var less = list.substr(0, 150);
                this.$('.industryKeywords').html(less);
                this.$('.industryKeywords').append('<span class="ellipses">...</span>');
                var more = list.substr(150, list.length);
                this.$('.industryKeywords').append('<span class="moreContent"></span>');
                this.$('.moreContent').html(more);
                this.showMoreLink();
            } else {
                this.$('.industryKeywords').html(list);
                this.hideShowMoreLink();
            }
        },
        buildParentCompanyDetails:function(){
            var record = this.model.get('record');
            var source = this.model.get('source');
            var sourceId = source.sourceId;
            var refId = source.refId;
            var name = record.name != "" ? record.name : "Unknown";
            var street = record.street != "" ? record.street : "Unknown";
            var city = record.city != "" ? record.city : "Unknown";
            var state = record.state != "" ? record.state : "Unknown";
            var country = record.country != "" ? record.country : "Unknown";
            var zip = record.postalCode != "" ? record.postalCode : "Unknown";
            var location = street + ", " + city + ", " + state + ", " + country + ", " + zip;
            var duns = source.refId != 0 ? source.refId : null;
            var isGlobalUltimate = record.isGlobalUltimate;

            if(duns != null){
                for(var i = duns.toString().length; i < 9; i++){
                    duns = "0" + duns;
                }
            }

            if(isGlobalUltimate){ // if this is the global ultimate parent
                this.$('.name').parent().hide();
                this.$('.location').parent().hide();
                if(this.model.get('source').sourceId == 90){
                    this.$('.DUNs').remove();
                    // if(this.parent.parent.model.get("hasHierarchy")){ // if this company contains subsidaries
                    //     this.$('.viewParent').html("View Hierarchy");
                    //     this.$('.viewParent').addClass('hierarchy');
                    //     this.$('.viewParent').removeAttr("href");
                    //     this.$('.viewParent').removeAttr("target");
                    // }else{
                    //     this.$('.viewParent').parent().hide();
                    // }
                } else{
                    // this.$('.viewParent').parent().hide();
                }
            } else{
                this.$('.name').html(name);
                this.$('.location').append(location);
                this.$('.viewParent').attr("href", '#profile/organization/' + sourceId + '/' + refId);
                if(this.model.get('source').sourceId == 46){
                    this.$('.DUNs').append("<b>D-U-N-S Number:</b> " + duns);
                } else {
                    this.$('.DUNs').remove();
                }
                if(this.model.get('source').sourceId == 90){
                    this.$('.DUNs').remove();
                    // if(this.parent.parent.model.get("hasHierarchy")){ // if this company contains subsidaries
                    //     this.$('.viewParent').html("View Hierarchy");
                    //     this.$('.viewParent').addClass('hierarchy');
                    //     this.$('.viewParent').removeAttr("href");
                    //     this.$('.viewParent').removeAttr("target");
                    // }else{
                    //     this.$('.viewParent').parent().hide();
                    // }
                }

            }

            this.$('.sourceName').html(window.utils.identity.makeSourceName(
                this.model.get('source').sourceId)
            );
        },
        showMoreLink: function(){
            this.$('.seeMore').show();
        },
        hideShowMoreLink: function() {
            this.$('.seeMore').hide();
        },
        appendByCommaNoAnd:function(list){
            var returnVal = "";
            for(var i = 0; i < list.length; i++){
                if(i == (list.length-1)){
                    returnVal += list[i]["keyword"];
                } else {
                    returnVal += list[i]["keyword"] + ", ";
                }
            }
            return returnVal;
        },
        appendByCommaNoAnd2 : function(list) {
            var returnVal = "";
            for(var i = 0; i < list.length; i++){
                if(i == (list.length-1)){
                    returnVal += list[i];
                } else {
                    returnVal += list[i] + ", ";
                }
            }
            return returnVal;
        },
        procRetrieveInferredEmail:function(){
            this.inferredEmailModel = new InferredEmailModel({id: this.parent.parent.model.get('id')});
            this.listenToOnce(this.inferredEmailModel, 'sync', this.procRenderInferredResults, this);
            this.$('.showLoader').show();
            this.$('.showLink').hide();
            this.inferredEmailModel.fetch();
        },
        procRenderInferredResults:function(){
            this.$('.showLoader').hide();
            this.$('.showLink').remove();
            if(this.inferredEmailModel.isValid()){
               this.renderEmailAndAccuracy(this.inferredEmailModel.get('email'), this.inferredEmailModel.get('accuracy'));
            } else {
                this.$('.showLink').show();
                this.errOut(this.inferredEmailModel.errorMessage);
            }
        },
        renderEmailAndAccuracy:function(email, accuracy){
            this.$('.hasInferredEmail').show();
            if(email == "Not found" && accuracy == 0){
                this.$('.emailAddress').html("Skrapp cannot infer the email.");
                this.$('.accuracy').hide();
            } else {
                this.$('.emailAddress').html('<a class="clickable" href="mailto:'+email+'">'+email+'</a>');
                this.$('.emailAddress .clickable').click(function (){
                    window.open( "mailto:"+email, '_blank');
                });
                this.$('.accuracy').html('Accuracy: ' + accuracy + '%');
            }
        },
        buildCompanyDetails:function(){
            var record = this.model.get('record');
            var num = record.revenue != 0 ? this.formatRevenue(record.revenue) : "Unknown";
            var emp = record.employees != 0 ? window.utils.numberWithCommas(record.employees) : "Unknown";
            var year = record.employees != 0 ? window.utils.numberWithCommas(record.employees) : "Unknown";
            var duns = record.DUNS != 0 ? record.DUNS : null;
            if(duns != null){
                for(var i = duns.toString().length; i < 9; i++){
                    duns = "0" + duns;
                }
            }

            var year = record.yearFound != 0 ? record.yearFound : "Unknown";

            this.industryCodes = new IndustryCodesModel();
            var codes = this.industryCodes.codes;
            var code = _.filter(codes, function(code){
                return record.relProIndustryId == code.id;
            });
            if(num != "Unknown") this.$('.revenue').append("<b>Revenue:</b> " + num);
            if(emp != "Unknown") this.$('.numberOfEmployees').append("<b>Employees:</b> " + emp);

            if(this.model.get('source').sourceId == 46 || this.model.get('source').sourceId == 90){
                this.$('.yearFounded').append("<b>Year Founded:</b> " + year);
            } else {
                this.$('.yearFounded').remove();
            }


            if(this.model.get('source').sourceId == 46){
                this.$('.DUNs').append("<b>D-U-N-S Number:</b> " + duns);
            } else {
                this.$('.DUNs').remove();
            }

            if(code.length == 1){
                this.$('.industryClassification').append("<b>Industry:</b> " + code[0].name);
            }
            this.$('.sourceName').html(window.utils.identity.makeSourceName(
                this.model.get('source').sourceId)
            );
        },
        buildFinanceCompanyDetails:function(){
            var record = this.model.get('record');
            var num = record.totalFundingAmount != 0 ? this.formatRevenue(record.totalFundingAmount / 1000) : "Unknown";
            var fundingStatus = record.fundingStatus != "" ? record.fundingStatus : "Unknown";
            if(fundingStatus == "ipo"){
                fundingStatus = fundingStatus.toUpperCase();
            }
            var lastFundingType = record.lastFundingType != "" ? record.lastFundingType : "Unknown";

            if(num != "Unknown") this.$('.totalFunding').append("<b>Total Funding USD:</b> " + num);
            if(fundingStatus != "Unknown") this.$('.fundingStatus').append("<b>Funding Status:</b> " + fundingStatus);
            if(lastFundingType != "Unknown") this.$('.fundingRound').append("<b>Latest Funding Round:</b> " + lastFundingType);
            this.$('.sourceName').html(window.utils.identity.makeSourceName(
                this.model.get('source').sourceId)
            );
        },
        formatRevenue:function ( value ) {
            if (value == 0) {
                return "$" + 0;
            } else if (parseInt(value).toString().length <= 3) {
                return "$" + parseInt(value) + " Thousand "
            } else if (parseInt(value).toString().length <= 6) {
                var s = parseInt(parseInt(value).toString().substr(0, parseInt(value).toString().length - 1))/100;
                return "$" + s + " Million"
            } else if (parseInt(value).toString().length <= 9) {
                var s = parseInt(parseInt(value).toString().substr(0, parseInt(value).toString().length - 4))/100;
                return "$" + s + " Billion"
            }
        },
        buildUserDefinedCard:function(){
            var record = this.model.get('record');
            this.$('.title').html(record.title);
            this.$('.description').html(record.description);
            this.$('.sourceName').html(record.author);
        },
        buildEmploymentCard:function(){
            var record = this.model.get('record');
            this.$('.role').html(record.role);
            this.$('.company').html(record.company);
            if(record.relatedPartySource.sourceId != undefined && record.relatedPartySource.refId != ""){
                this.$('.company').attr("href", '#profile/organization/' + record.relatedPartySource.sourceId + '/' + record.relatedPartySource.refId);
            }
            if(record.roleDescription != ""){
                this.$('.roleDescription').html(record.roleDescription);
            } else {
                this.$('.roleDescription').parent().remove();
            }
            this.renderDate(record.startDate, record.endDate, record.isCurrent);
        },
        procLinkedIn:function(){
            window.utils.identity.procLinkedIn(this.model, this.parent.parent);
        },
        buildEmployeeCard:function(){
            var record = this.model.get('record');
            this.$('.personName').html(record.firstName + " " +record.lastName);
            if(record.relatedPartySource.sourceId != undefined && record.relatedPartySource.refId != ""){
                this.$('.personName').attr("href", '#profile/person/' + record.relatedPartySource.sourceId + '/' + record.relatedPartySource.refId);
                //Prospector.navigate(this.clickUrl,true);
            }
            this.$('.personRole').html(record.role);
            if (record.roleDescription != undefined && record.roleDescription != "") {
                this.$('.personRoleDescription').html(record.roleDescription);
            } else {
                this.$('.personRoleDescription').parent().remove();
            }
            var date = window.utils.formatDate(record.lastUpdated);

            var contactDetails = record.relatedPartyContactDetails;

            var hideCount = 0;
            if(contactDetails != undefined){
                if(!contactDetails.hasDirectPhone){
                    this.$('.hasDirectPhone').hide();
                    hideCount++;
                }

                if(!contactDetails.hasCompanyPhone){
                    this.$('.hasCompanyPhone').hide();
                    hideCount++;
                }
                if(!contactDetails.hasEMails){
                    this.$('.hasEmail').hide();
                    hideCount++;
                }
                if(!contactDetails.hasLocations){
                    this.$('.hasLocation').hide();
                    hideCount++;
                }
                if(!(window.entitlements.get('settings').allowDotAlign && record.totalConnections > 0)){
                    this.$('.hasDotAlign').hide();
                    hideCount++;
                }
            }

            if(window.entitlements.get('settings').allowDotAlign && record.totalConnections > 0){
                this.$('.hasDotAlign').show();
                this.$('.connections').html(record.totalConnections);
                this.$('.avgScore').html(record.avgScore);
                this.$('.maxScore').html(record.maxScore);
                this.$('.colleagues').html(record.colleagues);
            } else {
                this.$('.hasDotAlign').remove();
            }

            if(contactDetails == undefined || hideCount == 5){
                this.$('.hasContactDetails').hide();
            }

            if (date != "") {
                this.$('.lastUpdate').html('As of ' + date);
            } else {
                this.$('.lastUpdateHolder').remove();
            }
            this.renderDate(record.startDate, record.endDate, record.isCurrent);
        },
        buildFavoriteRoles: function(){
            this.buildEmployeeCard();
            //return role bin view
            var view = new RoleBinView({model:this.model});
            this.$('.personRoleBin').append(view.render().el);
        },
        clickPersonName:function(){
            var person = this.model.get("record");
            this.clickName(person, 'person', person.firstName, 'person', false,  person.lastName, person.role, window.currentProfile.get('name'));
        },
        clickOrgName:function(){
            var org = this.model.get("record");
            this.clickName(org, 'organization', org.company, 'organization', true);
        },
        clickName:function(record, identityType, mainName, tab, state, lastName, title, company){
            if(record.relatedPartySource.sourceId != undefined && record.relatedPartySource.refId != ""){
                this.clickUrl = 'profile/' + identityType + '/' + record.relatedPartySource.sourceId + '/' + record.relatedPartySource.refId;
                Prospector.navigate(this.clickUrl,true);
            }
            this.performSearch(mainName, tab, state, lastName, title, company);
        },
        performSearch:function(name, tab, state, lastName, title, company) {
            if(state){
                var options = {
                    state: state,
                    main: name,
                    lastName: '',
                    company: '',
                    titleRole: '',
                    tab: tab
                };
            } else {
                var options = {
                    state: state,
                    main: name,
                    lastName: lastName,
                    companyName: company,
                    titleRole: title,
                    tab: tab
                };
            }
            Prospector.trigger('runSubSearch', options);
            Prospector.trigger("openSideDrawer", {
                passedFunc: function () {
                    $(".verticalIcon").removeClass('active');
                    $(".verticalIcon.search").addClass('active');
                    $('.searchViewHolder').show();
                }
            });
        },
        openWebsiteLink:function(){
            var record = this.model.get('record');
            if (record.url.indexOf('http://') > -1) {
                window.open(record.url, '_blank');
            } else {
                window.open("http://" + record.url, '_blank');
            }

        },
        openMediaLink:function(){
            // var record = this.model.get('record');
            // window.open(record.link, '_blank');
            var record = this.model.get('record');
            return record.link;
        },
        buildDnBData:function(selector){
            this.$(selector).html('Show D&B data.');
            this.$(selector).addClass('clickable');
            this.$(selector).bind('click', $.proxy(function(){
                this.parent.showDnBData();
            }, this));
        },
        buildWebsiteLink:function(){
            var selector = ".website";
            var record = this.model.get('record');
            if(this.needsDnB(record.url)){
                this.buildDnBData(selector);
            } else {
                this.$(selector).html(record.url);
                if (record.url.indexOf('http://') == -1 && record.url.indexOf('https://') == -1) {
                    record.url = "http://" + record.url;
                }
                this.$(selector).attr("href", record.url);

            }
        },
        buildPhoneNumber:function(){
            var record = this.model.get('record');
            this.$('.contactType').html(record.type);
            if (record.type == "direct") {
                this.$('.hasPhone').addClass("relpro-sk relpro-sk-phone-direct")
            } else {
                this.$('.hasPhone').addClass("icon-phone");
            }
            var selector = '.contactInfo';
            if(this.needsDnB(record.phoneNumber)){
                this.buildDnBData(selector);
            } else {
                this.$('.contactInfo').html('<a class="clickable" href="tel:'+record.phoneNumber+'">'+record.phoneNumber+'</a>');
                this.$('.contactInfo .clickable').click(function (){
                    window.open("tel:"+record.phoneNumber, '_blank');
                });
            }
        },
        buildEmail:function(){
            var record = this.model.get('record');
            this.$('.contactType').html(record.type);
            var selector = '.emailAddress';
            if(this.needsDnB(record.email)){
                this.buildDnBData(selector);
            } else {
                this.$(selector).html('<a class="clickable" href="mailto:'+record.email.toLowerCase()+'">'+record.email.toLowerCase()+'</a>');
                this.$('.emailAddress .clickable').click(function (){
                    window.open("mailto:"+record.email.toLowerCase(), '_blank');
                });
            }
        },
        needsDnB:function(field){
            return field == "" && ( this.model.get('source').sourceId == 46 || this.model.get('source').sourceId == 1046);
        },
        buildEducationCard:function(){
            var record = this.model.get('record');
            this.$('.role').html(record.role);
            this.$('.company').html(record.company);
            this.renderDate(record.startDate, record.endDate, record.isCurrent);
            this.$('.sourceName').html(window.utils.identity.makeSourceName(
                this.model.get('source').sourceId)
            );
        },
        buildAddress:function(){
            var record = this.model.get('record');
            var address = window.utils.identity.buildAddressByRecord(record);
            this.$('.address').html(address);
        },
        buildDescription:function(){
            var record = this.model.get('record');
            this.$('.secondaryLineFont').html(record.description)
        },
        buildProfileCard:function(){
            var record = this.model.get('record');
            this.$('.role').html(record.role);
            this.$('.company').html(record.company);
            if(window.entitlements.get('settings').allowDotAlign && record.relationshipScore > 0){
                this.$('.userConnection').html(record.relationshipScore);
                this.$('.hasDotAlign').show();
            }else{
                this.$('.hasDotAlign').remove();
            }
            this.$('.name').html(record.firstName + " " + record.lastName);
            if(record.imageURL != ""){
                this.$('.profileIcon').html('<img src="' +record.imageURL+ '" class="personImage">');
            }
            var date = window.utils.formatDate(record.lastUpdated);
            if (date != "") {
                this.$('.lastUpdate').html('As of ' + date);
            }
        },
        replaceImage:function(event){
            if(window.currentProfile.get('identityType') == "person"){
                this.$(".profileIcon").html('<div class="relpro relpro-person_silo text-center"></div>');
            } else {
                this.$(".profileIcon").html('<div class="relpro relpro-building text-center"></div>');
            }
        },
        buildOrgProfileCard:function(){
            var record = this.model.get('record');
            this.$('.name').html(record.name);
            if(record.imageURL != ""){
                this.$('.profile_pic').attr("style", "content:url("+record.imageURL+")");
            } else if(record.url != ""){
                var logoUrl = window.utils.identity.getDomain(record.url);
                if (logoUrl) {
                    this.$('.profileIcon').html('<img class="companyLogo" src="https://s3.amazonaws.com/relpro-company-logos/' + logoUrl + '.png">');
                }
            }
            if(record.lastUpdated != undefined && record.lastUpdated != ""){
                var date = new Moment(record.lastUpdated, 'YYYY-MM-DD');
                this.$('.lastUpdate').html('Last Updated: ' + date.format('M/D/YYYY'));
            }
        },
        buildHG:function(){
            var record = this.model.get('record');
            var hgProducts = JSON.parse(record.products);
            if(hgProducts != undefined && hgProducts != null){
                var hgError = JSON.parse(record.products).error;
                var html = "";
                window.utils.rawOutput("er=" + JSON.stringify(hgError));
                if (hgError.length == 0) {
                    var hgData = JSON.parse(record.products).products;
                    if (hgData.length > 0) {
                        var categories = new Array();
                        var lastCatLabel = "";
                        var lastVenLabel = "";
                        var lastProdLabel = "";
                        _.each(hgData, function (data) {
                            if ($.trim(data.fields.category_name[0]) != lastCatLabel) {
                                lastCatLabel = $.trim(data.fields.category_name[0]);
                                lastVenLabel = $.trim(data.fields.vendor_name[0]);
                                lastProdLabel = $.trim(data.fields.product_name[0]);
                                categories.push({
                                    name: lastCatLabel,
                                    vendors: [{
                                        name: lastVenLabel,
                                        products: [lastProdLabel]
                                    }]
                                });
                            } else if ($.trim(data.fields.vendor_name[0]) != lastVenLabel) {
                                lastVenLabel = $.trim(data.fields.vendor_name[0]);
                                lastProdLabel = $.trim(data.fields.product_name[0]);
                                categories[categories.length - 1].vendors.push({
                                    name: lastVenLabel,
                                    products: [lastProdLabel]
                                });
                            } else if ($.trim(data.fields.product_name[0]) != lastProdLabel) {
                                lastProdLabel = $.trim(data.fields.product_name[0]);
                                var cat = categories[categories.length - 1];
                                var ven = cat.vendors[cat.vendors.length - 1];
                                ven.products.push(lastProdLabel);
                            }
                        }, this);
                        _.each(categories, function (cat) {
                            html += "<div><div class='category'>" + cat.name + "</div><div>";
                            _.each(cat.vendors, function (ven) {
                                html += "<div><div class='vendor'>" + ven.name;
                                _.each(ven.products, function (prod) {
                                    html += "<div class='product'>" + prod + "</div>";
                                }, this);
                                html += "</div></div>";
                            }, this);
                            html += "</div></div>";
                        }, this);
                    } else {
                        var hgCategories = JSON.parse(record.products).categories;
                        var cats = "";
                        _.each(hgCategories, function (cat) {
                            cats += "<li class='errorCategory'>" + cat.categoryName + "</li>";
                        });
                        this.$('.data').append("<div class='secondaryLineFont mTop20 mBottom20'>No results found. Why?<br><br>Either this company has not been analyzed by HG Data yet, or...<br><br>HG Data did not find any references indicating that the company uses the vendors/products currently tracked in the following categories:<br><br><ul>" + cats + "</ul></div>");
                    }
                } else {
                    this.$('.data').append("<div class='secondaryLineFont mTop20 mBottom20'>" + hgError.message + "</div>");
                }
                this.$('.data').append(html);
            } else {
                this.$('.data').append("<div class='secondaryLineFont mTop20 mBottom20'>There was an error retrieving the data from the servers. Please reload the profile page or email <a href='mailto:support@relpro.com'>support@relpro.com</a> if this issue persists.</div>");
            }
        },
        buildMediaArticle:function(){
            var record = this.model.get('record');
            this.$('.title').html(record.title);

            this.$('a.title').attr("href",this.openMediaLink());
            this.$('a.title').attr("target","_blank");

            this.$('.snippet').html(record.snippet);
            if(record.imageURL != ""){
                this.$('.articleImage').show();
                this.$('img').attr('src', record.imageURL);
            } else {
                this.$('.articleImage').hide();
            }
            this.$('.sourceName').html(record.displayLink);
        },
        renderDate:function(startDate, endDate, isCurrent){
            var text = window.utils.identity.renderDate(startDate, endDate, isCurrent);
            if(text != ""){
                this.$('.date').html(text);
            } else {
                this.$('.dateHolder').hide();
            }
        },
        saveCard:function(callback, scope){
            if(this.parent.model.canModifyBoard()){
                if(this.model.canModifyCard()){
                    $.proxy(callback, scope)();
                } else {
                    this.model.set({
                        id: undefined,
                        boardId: this.parent.model.get('id')
                    });
                    this.model.once('sync', callback, scope);
                    this.currXHR = this.model.save();
                }
            } else {
                var func = $.proxy(function(){
                    this.saveCard(callback, scope)
                }, this);
                this.parent.saveBoard(func, this);
            }
        },
        procEditArticle:function(event){
            //parent that refers to this view --calls profile.module.js to trigger modal
            Prospector.trigger("showEditArticle", {parent: this});
        },
       /* procHideArticle: function(event){
            this.newsArticleModel = new NewsArticleModel(this.model.get("record"));
            this.newsArticleModel.set({relevant: false}); //set flag to false to hide
            this.newsArticleModel.once('sync', this.procHide, this);
            this.newsArticleModel.save();
        },*/
        procHide:function(){
            this.removeThis('fadeOut', 500);
        },
        removeThis:function(animate, length){
            $(this.el).addClass('animated').addClass(animate);
            window.setTimeout($.proxy(this.procRemoveThis, this), length);
        },
        procRemoveThis:function(){
            this.unbind();
            this.remove();
            this.parent.fetchModel(); //refreshes model in real time - ajax
        }
    });
    return BoardView;
});
